import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { ThemeContext } from "../../theme/ThemeContext";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";

const BootstrapDialog = styled(Dialog)(({ theme, darkMode }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    width: "630px",
    backgroundColor: darkMode ? "#0E2A41" : "",
  },
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  marginLeft: "11px",
}));

export default function SessionExpiredModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { darkMode } = useContext(ThemeContext);
  const handleOkClick = () => {
    localStorage.clear();
    history.push("/vis/login");
    onClose(); // Close the modal after redirection
  };

  return (
    <BootstrapDialog
      maxWidth="lg"
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      onClose={null}
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
      darkMode={darkMode}
    >
      <DialogContent>
        <CustomTypography
          gutterBottom
          mt={1}
          style={{ color: darkMode ? "#fff" : "rgb(15, 90, 156)" }}
        >
          Attention!
        </CustomTypography>
        <Typography mt={1} ml={2} style={{ color: darkMode ? "#fff" : "" }}>
          {t("SESSION_EXPIRED")}
        </Typography>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          paddingRight: "20px",
          marginBottom: "7px",
        }}
      >
        <SubmitButtons variant="contained" onClick={handleOkClick}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("OK_BUTTON")}
          </Typography>
        </SubmitButtons>
      </DialogActions>
    </BootstrapDialog>
  );
}
